module.exports = __webpack_public_path__ + "img/1118539993.517100ad.png";